import { call, debounce, put, takeLatest } from 'redux-saga/effects';
import serviceUtil from 'src/Utils/serviceUtil/serviceUtil';
import {
  fetchCompanyListRequest,
  fetchCompanyListSuccess,
  fetchCompanyListFailure,
  updateCompanyStatusRequest,
  updateCompanyStatusSuccess,
  updateCompanyStatusFailure,
} from 'src/GlobalRedux/companyListSlice/companyListSlice';

interface FetchCompanyListAction {
  type: string;
  payload: {
    search: string;
    page: number;
    perPage: number;
    sortBy?: string;
    sortOrder?: string;
  };
}

interface UpdateCompanyStatusAction {
  type: string;
  payload: {
    companyId: number;
    isEnabled: boolean;
    search: string;
    page: number;
    perPage: number;
    sortBy?: string;
    sortOrder?: string;
  };
}

export function* fetchCompanyListSaga(action: FetchCompanyListAction) {
  try {
    const { search, page, perPage, sortBy, sortOrder } = action.payload;
    const response: { status: number; data: { data: any } } = yield call(serviceUtil.get, `${process.env.NEXT_PUBLIC_API_URL}/identity/company`, {
      page,
      perPage,
      sortBy,
      sortOrder: sortOrder ? (sortOrder === 'ascend' ? 'ASC' : 'DESC') : undefined,
      search,
    });

    if (response.status === 200) {
      yield put(fetchCompanyListSuccess(response.data));
    } else {
      yield put(fetchCompanyListFailure('Failed to fetch company list'));
    }
  } catch (error: any) {
    yield put(fetchCompanyListFailure(error.message));
  }
}

export function* updateCompanyStatusSaga(action: UpdateCompanyStatusAction) {
  try {
    const { companyId, isEnabled, search, page, perPage, sortBy, sortOrder } = action.payload;
    const url = `${process.env.NEXT_PUBLIC_API_URL}/identity/company/${companyId}`;
    const response: { status: number; data: { message: string } } = yield call(serviceUtil.patch, url, { Is_Enable: isEnabled });

    if (response.status === 200) {
      yield put(updateCompanyStatusSuccess({ companyId, isEnabled, message: response.data.message }));
    } else {
      yield put(updateCompanyStatusFailure('Failed to update company status'));
    }
  } catch (error: any) {
    yield put(updateCompanyStatusFailure(error.message));
  }
}

export function* watchCompanyList() {
  yield debounce(500, fetchCompanyListRequest.type, fetchCompanyListSaga);
  yield takeLatest(updateCompanyStatusRequest.type, updateCompanyStatusSaga);
}
